import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import { setDisplayModal } from '@/redux/app/appSlice';

import RouteNames from '@/router/routes';

import Modal from '@/ui/modal';

import s from './modalSupportRequired.module.css';

const SUPPORT_ROUTE = `/${RouteNames.SUPPORT}`;

function ModalSupportRequired({ closeModal }) {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(SUPPORT_ROUTE);

    dispatch(setDisplayModal(false));

    closeModal();
  };

  return (
    <Modal close={handleClose}>
      <h2 className={s.title}>{i18n['Complete activation']}</h2>
      <p className={s.text}>
        {i18n[
          'An error occurred while submitting the data! Please contact the company`s support team.'
        ] ||
          'An error occurred while submitting the data! Please contact the company`s support team.'}
      </p>

      <button type="button" onClick={handleClose} className={s.btn_ok}>
        {i18n.Support}
      </button>
    </Modal>
  );
}

export default ModalSupportRequired;

ModalSupportRequired.propTypes = {
  closeModal: PropTypes.func,
};
